import type { PaymentTypeProp } from "@app/types/checkout-types";
import type {
  CheckoutCommonReduxState,
  CheckoutReduxStateV2
} from "@app/types/checkout-v2-types";
import type { ResultsReduxState } from "@app/types/results-redux-types";

import type { BillingFormReduxState } from "../slices/billing-info-form";

export const getCurrency = (state: CheckoutReduxStateV2) => state.currency;
export const getCart = (
  state: CheckoutReduxStateV2 | CheckoutCommonReduxState
) => state.cart;
export const getWhitelabel = (state: CheckoutReduxStateV2) => state.whitelabel;
export const getCartStatus = (state: CheckoutReduxStateV2): boolean =>
  !!state.cart_status?.loading;
export const getCartCharges = (state: CheckoutReduxStateV2) =>
  state.cart.charges;

export const getTripsSegments = (
  state: CheckoutCommonReduxState | ResultsReduxState
): Record<
  string,
  {
    operator_id: string;
    origin_id: number;
    destination_id: number;
    source_name?: string | undefined;
  }
> => state.trips_segments;

export const getTripsOperators = (
  state: CheckoutCommonReduxState | ResultsReduxState
) => state.trips_operators;

export const getBillingInfo = (state: CheckoutReduxStateV2) =>
  state.billing_info;

export const getUseBillingAddressForm = (
  state: CheckoutReduxStateV2
): boolean => state.use_billing_address_form;

export const getPaymentType = (state: CheckoutReduxStateV2): PaymentTypeProp =>
  state.payment_type;

export const getBillingAddressForm = (
  state: CheckoutReduxStateV2
): BillingFormReduxState => state.billing_info_form;

export const getShouldSaveBillingAddress = (
  state: CheckoutReduxStateV2
): boolean => state.save_user_info?.billing_address ?? false;

export const getPaymentInfo = (state: CheckoutReduxStateV2) =>
  state.payment_info;

export const getInstallmentsPlans = (state: CheckoutReduxStateV2) =>
  state.installments_plans;
